export const getCroppedImg = (imageSrc, crop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      canvas.width = crop.width;
      canvas.height = crop.height;

      ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

      const base64 = canvas.toDataURL('image/png'); // or 'image/jpeg'
      resolve(base64);
    };
    image.onerror = () => reject(new Error('Failed to load image'));
  });
};

export const getAssetImage = (asset) => {
  if (!asset.metadata?.media || asset.metadata.media.length === 0) {
    return null;
  }

  const pngImage = asset.metadata.media.find((m) => m.type === 'image/png');
  const svgImage = asset.metadata.media.find((m) => m.type === 'image/svg+xml');

  return pngImage?.url || svgImage?.url || asset.metadata.media[0].url;
};
